export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    contactName: {
      type: String,
      default: 'Contato'
    }
  },
  computed: {
    senderName () {
      return this.message?.direction === 'IN'
        ? this.contactName
        : 'Você'
    },
    borderColor () {
      return this.message?.direction === 'IN'
        ? '#26A69A'
        : '#29B6F6'
    },
    senderColor () {
      return this.message?.direction === 'IN'
        ? 'text-green-7'
        : 'text-light-blue-7'
    },
    quoteDetails () {
      if (!this.message) return { icon: null, text: '' }
      const { message, type } = this.message

      const getFileName = () => {
        try {
          const json = JSON.parse(message.replace(/(\r\n|\n|\r)/g, '\n'))
          return json.fileName || json.fileCaption
        } catch (e) {
          return null
        }
      }

      switch (type) {
        case 'TEXT':
          return { icon: null, text: message }
        case 'AUDIO':
          return { icon: 'mdi-microphone', text: 'Áudio' }
        case 'IMAGE':
          return { icon: 'mdi-image', text: getFileName() || 'Imagem' }
        case 'VIDEO':
          return { icon: 'mdi-video', text: getFileName() || 'Vídeo' }
        case 'DOC':
          return { icon: 'mdi-file-document-outline', text: getFileName() || 'Documento' }
        case 'LOCALIZATION':
          return { icon: 'mdi-map-marker-outline', text: 'Localização' }
        case 'CONTACT':
          return { icon: 'mdi-account-box-outline', text: 'Contato' }
        case 'TEMPLATE': {
          const json = getFileName()
          const body = typeof message === 'string' && message.startsWith('{') ? JSON.parse(message).body : null
          return { icon: 'mdi-file-document-outline', text: body || json || 'Template' }
        }
        default:
          return { icon: null, text: message }
      }
    }
  }
}
